

import AppRoute from "./router/AppRoute"
function App() {
  return (
    <AppRoute/>
  );
}

export default App;
